import { HeaderFieldCellMixins, FieldCellMixins } from './mixins.js';
import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

const user_cell_comp = {
  mixins: [FieldCellMixins],

  components: {
    'user-item': UserItem
  },

  template: `
    <div class="members-cell">
      <user-item v-for='entry in entries'
                 :key='entry.id'
                 :user='{ name: getUser(entry).name, headimgurl: getUser(entry).headimgurl }'
                 size='small' />
    </div>
  `,

  methods: {
    getUser: function(entry) {
      return entry.user || entry.member || entry.author;
    }
  }
};

const user_header_cell = {
  mixins: [HeaderFieldCellMixins],

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container">
        <div class="input-control left-addon">
          <input type="text"
                 class='controlled-input bordered'
                 placeholder='搜索'
                 v-model.trim='keyword'
                 @keyup.enter='updateFilter' />
          <div class="addon">
            <i class="slp-search"></i>
          </div>
        </div>
      </div>
    </div>
  `
};

export {
  user_cell_comp as MemberCell,
  user_cell_comp as UserCell,
  user_cell_comp as HoldUserCell,
  user_cell_comp as YAW__JourneyProposerCell
};

export {
  user_header_cell as HoldUserHeaderCell,
  user_header_cell as MemberHeaderCell,
  user_header_cell as YAW__JourneyProposerHeaderCell
};
